import { Action, Entity } from 'types/permissions'
import { TAttribute } from './Attribute'

export type TFlourWithId = {
  id: number
  name: string
  post_aging: boolean
  company_id?: number
  attributes: TAttribute[]
}

export type TFlourWithoutCategories = {
  id?: number
  name: string
  post_aging: boolean
  company_id?: number
  attributes: TAttribute[]
}

export type IFlourAttributes = {
  id?: number
  name: string
  unit?: string | null
  order: number
  is_lab?: boolean
  is_editable?: boolean
  is_mandatory: boolean
  category_id: number
  range_min?: string
  range_max?: string
  range_avg?: string
  min_value?: number
  max_value?: number
  warn_above?: number
  warn_below?: number
  hard_max?: number
  hard_min?: number
}

export type TFlourCategory = {
  id: number
  name: string
  attributes: IFlourAttributes[]
}

export type TFlourActionConfig<T> = {
  name: string
  icon: React.ReactNode
  handler: (row: TFlourWithoutCategories) => void
  permission?: { entity: Entity; action: Action }
  isCustom?: boolean
}

export type TFlourAttributeFilter = {
  id: number
  product_attribute_id: number
  checked: boolean
  post_aging: boolean
  is_mandatory: boolean
}

export type TFlourAttributeItem = {
  id: number
  name: string
  unit?: string
  order?: number
  is_mandatory?: boolean
  category_id: number
  checked: boolean
  range_max?: number
  range_min?: number
}

export type TFlourAttributeGroup = {
  id: number
  name: string
  attributes: TFlourAttributeItem[]
}

export type FlourFilterPayload = {
  attribute_ids: number[]
  post_aging: boolean
}

export type TFlourTimeFilterValues =
  | 'All'
  | 'Last Month'
  | 'Last Week'
  | 'Last 48 Hrs'
  | 'Last 24 Hrs'

export const timeFilters: TFlourTimeFilterValues[] = [
  'All',
  'Last Month',
  'Last Week',
  'Last 48 Hrs',
  'Last 24 Hrs',
]

export type TFlourFormValues = {
  id?: number
  name: string
  company_id?: number | string
  post_aging?: boolean
  attributes: Record<
    number,
    Record<number, { min: number | string; max: number | string }>
  >
}

export type TProductWithDeliveries = {
  id: number
  name: string
  last_entry: string
  total_entries: number
  consistent_entries: number
  inconsistent_entries: number
  created: string
  created_by: string
  post_aging: boolean
  company_id: number
}

export const flourAttributesWithCategories = [
  {
    id: 1,
    name: 'NIR',
    attributes: [
      {
        id: 1,
        name: 'Protein',
        unit: '%',
        order: 1,
        is_mandatory: true,
        category_id: 1,
      },
      {
        id: 2,
        name: 'Water Absorption',
        unit: '%',
        order: 2,
        is_mandatory: true,
        category_id: 1,
      },
      {
        id: 3,
        name: 'Moisture',
        unit: '%',
        order: 3,
        is_mandatory: true,
        category_id: 1,
      },
      {
        id: 4,
        name: 'Ash',
        unit: '%',
        order: 4,
        is_mandatory: true,
        category_id: 1,
      },
      {
        id: 5,
        name: 'Damaged Starch',
        unit: '%',
        order: 5,
        is_mandatory: true,
        category_id: 1,
      },
    ],
  },
  {
    id: 2,
    name: 'Extensograph',
    attributes: [
      {
        id: 6,
        name: 'Extensibility (nm)',
        unit: null,
        order: 1,
        is_mandatory: false,
        category_id: 2,
      },
      {
        id: 7,
        name: 'Resistance (BU)',
        unit: null,
        order: 2,
        is_mandatory: false,
        category_id: 2,
      },
      {
        id: 8,
        name: 'R/E (nm)',
        unit: null,
        order: 3,
        is_mandatory: false,
        category_id: 2,
      },
    ],
  },
  {
    id: 3,
    name: 'Alveograph',
    attributes: [
      {
        id: 9,
        name: 'W (cm²)',
        unit: null,
        order: 1,
        is_mandatory: false,
        category_id: 3,
      },
      {
        id: 10,
        name: 'Elasticity V (cm³)',
        unit: null,
        order: 2,
        is_mandatory: false,
        category_id: 3,
      },
      {
        id: 11,
        name: 'P/L (nm)',
        unit: null,
        order: 3,
        is_mandatory: false,
        category_id: 3,
      },
    ],
  },
  {
    id: 4,
    name: 'Color',
    attributes: [
      {
        id: 12,
        name: 'L Brightness (nm)',
        unit: null,
        order: 1,
        is_mandatory: false,
        category_id: 4,
      },
      {
        id: 13,
        name: 'A Redness (nm)',
        unit: null,
        order: 2,
        is_mandatory: false,
        category_id: 4,
      },
      {
        id: 14,
        name: 'B Yellowness (nm)',
        unit: null,
        order: 3,
        is_mandatory: false,
        category_id: 4,
      },
    ],
  },
]
